/* @flow */

import { buttonModalActionMaker } from '@website/components/ActionMakers'
import { addButton } from '@website/components/CommonActions'

export default dispatcher => ({
  addButton: () => dispatcher(addButton()),
  getButtonActions: buttonModalActionMaker(dispatcher)
})
